module.exports = __webpack_public_path__ + "img/mark_s.8c8155ba.png";